import { InboxMessage } from 'all-in-one-shared-api';

export interface InboxMessagesState {
  inboxMessages: InboxMessage[];
  unreadMessageCount: number;
}

export enum InboxMessageActionTypes {
  GET_MESSAGES,
}

interface GetInboxMessages {
  type: InboxMessageActionTypes.GET_MESSAGES;
  payload: InboxMessagesState;
}

export type InboxMessagesActions = GetInboxMessages;
